const styles = ({ palette }) => ({
  "&[data-status='PENDING'], &[data-status='Pending'], &[data-status='pending']": {
    '& .status': {
      '&.notMandatory': {
        color: 'initial',
      },
      color: palette.error,
    },
  },
});

export default styles;
